<template>
<div class="content-list">
    <Tabs ref="tabs" @on-tab-remove="handleClose" v-model="tabActiveKey" :value="tabActiveKey" type="line">
        <TabPane key="001" name="tabItem0" label="自定义表单">
            <Form class="search-form" ref="formCustom" :model="formCustom" :label-width="120">
                <Row>
                    <i-col :xs="8" :sm="8" :md="8" :lg="8">
                        <FormItem label="活动名称" prop="activityName">
                            <span slot="label">{{$t('活动名称')}}</span>
                            <Input v-model="formCustom.activityName" clearable/>
                        </FormItem>
                    </i-col>
                    <i-col :xs="8" :sm="8" :md="8" :lg="8">
                        <FormItem label="活动编码" prop="activityCode">
                            <span slot="label">{{$t('活动编码')}}</span>
                            <Input v-model="formCustom.activityCode" clearable/>
                        </FormItem>
                    </i-col>
                    <i-col :xs="7" :sm="7" :md="7" :lg="7" offset="1">
                          <div class="btn-tool" style="margin: 0px;">
                              <Button style="margin: 0px 10px 0 0" type="primary" v-on:click.stop="handleSubmit('formCustom')" v-perm:SER.permission.roleManage.listRoleList>{{$t('com.btn.search')}}</Button>
                              <Button style="margin: 0px" type="ghost" @click="handleReset('formCustom')" v-perm:SER.permission.roleManage.listRoleList>{{$t('com.btn.reset')}}</Button>
                          </div>
                      </i-col>
                </Row>
            </Form>
            <div>
                <ihr ></ihr>
            </div>
            <div>
                <div class="btn-tool align-right">
                    <div class="table-title">
                        <ih7 :cfg="{label:'自定义表单列表'}"></ih7>
                    </div>
                    <Button type="ghost" @click="create">{{$t('创建活动')}}</Button>
                </div>
                <Table size="small" border ref="listTable" :columns="columns" :data="tableData"></Table>
                <page v-bind:pageVO='pageVO' @pageVOChange='pageVOChange'></page>
            </div>
        </TabPane>
        <TabPane closable v-for="tab in tabs" :name="tab.name" :key="tab.tabId" :label="tab.title">
            <component :ref='tab.name' v-bind:tabelSelect="tabelSelect" tabItemName='tab.name' @handleSubmit="handleSubmit" @handleClose='handleClose' v-bind:is="tab.component"></component>
        </TabPane>
    </Tabs>
</div>
</template>


<script>
import Add from "./add";
import Update from "./update";
import { mapGetters, mapState } from "vuex";
import Resume from "@/page/publicResume/resume"; //履历

export default {
  components: { Add, Update,Resume },
  data() {
    return {
      pageVO: { curPage: 1, pageSize: 10, totalRows: 10 },
      tabs: [],
      tabActiveKey: "tabItem0",
      tabItemNum: 0,
      dataList: { value: [] },
      formCustom: {
        activityName: "",
        activityCode: ""
      },
      columns: [],
      tableData: [],
      tabelSelect: {}
    };
  },
  created() {
    this.setTableHeadTitle();
  },
  //初始化后调用
  mounted: function() {
    this.handleSubmit();
  },
  methods: {
    //添加tabItem
    handleTabsAdd(tabItem) {
      this.tabItemNum++;
      tabItem.name = tabItem.name || "tabItem" + this.tabItemNum;
      this.tabs.push(tabItem);
      this.tabActiveKey = tabItem.name;
    },

    //分页子组件值改变触发该方法
    pageVOChange(pageVO) {
      Object.assign(this.pageVO, pageVO);
      this.handleSubmit();
    },
    setTableHeadTitle() {
      var self = this;
      const columns = [
        {
          fixed:"left",
          title: this.$t("com.serialNumber"),
          align: "center",
          width: 80,
          type: "index"
        },
        {   //操作
          fixed:"left",
          title: self.$t('操作'),
          key: 'refundBatchNo',
          width: 240,
          edit: "true",
          type: "btns",
          align: "center",
          editCfg: {
              btns: [
                {
                  type: "text",
                  icon: "edit ihlp-icon-btn",
                  size: "small",
                  //权限点配置
                  //'v-perm':"SER.xxxx",
                  // title: self.$t("com.edit"),
                  class: "table-text-btn",
                  onClick: function(col, row) {
                      self.update(row)
                  },
                },
                {
                  type: "text",
                  iconPrefixCls: "ihlp-icon-r",
                  iconColor: "#009BC8",
                  icon: "stop-circle",
                  size: "small",
                  title:self.$t("门店导出"),
                  //权限点配置
                  //'v-perm':"SER.xxxx",
                  // title: self.$t("com.edit"),
                  class: "table-text-btn",
                  onClick: function(col, row) {
                      self.exportStore(row)
                  },
                },
                  {
                  type: "text",
                  icon: "download",
                  size: "small",
                  title:self.$t("门店导出"),
                  //权限点配置
                  //'v-perm':"SER.xxxx",
                  // title: self.$t("com.edit"),
                  class: "table-text-btn",
                  onClick: function(col, row) {
                      self.exportStore(row)
                  },
                },
                {
                  type: "text",
                  icon: "file-alt",
                  size: "small",
                  // title: self.$t("查看"),
                  class: "table-text-btn",
                  onClick: function(col, row, rowOriginal) {
                    self.showOperate(row);
                  }
                },
              ]
          }
      },
       {
          title: self.$t("活动编码"),
          key: "activityCode"
        },
        {
          title: self.$t("活动标题"),
          key: "activityName"
        },
        {
          title: self.$t("创建时间"),
          key: "creationDate"
        },
        {
          title: self.$t("创建人"),
          key:"createdBy",
          format: {
          label: "displayname",
          key: "uuid",
          dataCfg: {
            sc: "user",
            paramsStr: "uuidString",
            url: "userManager/getUserByUUIDStringLocal"
          }
        }
        },
        {
          width: 160,
          title: self.$t("活动状态"),
          key: "activityStatus",
          format: {
            label: "label",
            key: "value",
            value: [
              {
                value: "0",
                label: "未开始"
              },
              {
                value: "1",
                label: "进行中"
              },
              {
                value: "3",
                label: "已终止"
              }
            ]
          }
        },
        {
          title: self.$t("数据统计"),
          key: "activityUrl;"
        },
        {
          title: self.$t("活动链接"),
          key: "activityUrl;"
        },
      ];
      this.columns = columns;
    },
    //查询
    handleSubmit(name) {
      let pageVO = this.pageVO;
      let self = this;
      let params = {
        curPage: pageVO.curPage,
        pageSize: pageVO.pageSize,
        filter: self.formCustom
      };
      this.$api.post(
        "activityQuestion/listActivityQuestionPaging",
        params,
        r => {
          const list = r.result || [];
          self.tableData = r.result;
          if (list.length > 0) {
            Object.assign(pageVO, list[0].pagingMap);
          } else {
            self.pageVO.curPage = -1;
          }
        },
        null,
        "marketing"
      );
    },
    //清空
    handleReset(name) {
      this[name] = this.$options.data()[name];
    },
    //子页面关闭tab调用方法
    handleClose(tabItemName) {
      let tabs = this.tabs;
      for (let i = 0; i < tabs.length; i++) {
        let tab = tabs[i];
        if (tab.name === tabItemName) {
          tabs.splice(i, 1);
          break;
        }
      }
      this.tabActiveKey = "tabItem0";
    },
    //打开角色创建tab
    create() {
      this.handleTabsAdd({
        title: "创建活动",
        component: Add,
        tabId: this.tabItemNum
      });
    },
    //打开创建页面
    update(row) {
      this.tabelSelect = row;
      this.handleTabsAdd({
        title: "修改活动",
        component: Update,
        tabId: this.tabItemNum
      });
    },
    clickDelete() {
      let self = this;
    },
      //打开操作履历
    showOperate(row) {
      this.tabelSelect = row;
      this.handleTabsAdd({
        title: this.$t("操作履历"),
        closable:true,
        component: Resume,
        tabId: this.tabItemNum
      });
    },
    exportStore(row){
      let self=this;
      self.$api.post({
          sc: "marketing",
          url: "activityItemChannel/channelExportByActivityCode/"+row.activityCode,
          params:null,
          success: r => {
          self.$utils.tips.gotoExportQuery(self);
          }
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/customForm/list.vue